import { Component, OnInit } from '@angular/core';
import {ModalInterface} from "../modal-basic/ModalInterface";

@Component({
  selector: 'app-modal-confirmacion',
  templateUrl: './modal-confirmacion.component.html'
})
export class ModalConfirmacionComponent extends ModalInterface implements OnInit {


  constructor() {
    super();
  }

  ngOnInit() {
  }

  confirmar() {
    this.result.emit(true);
    this.modal.hide();
  }


}
